const supportTime = 'M-F, 6:00am–12:00pm PST';
export default supportTime;
